import { compose, withHandlers, defaultProps } from 'recompose';
import { noop } from 'lodash';

import setWrappedDisplayName from 'decorators/setWrappedDisplayName';
import { setLocation } from 'utils/helpers';
import {
	trackContactLinkClick,
	trackOutboundLinkClick,
} from './clickTrackingUtils';

const enhance = compose(
	defaultProps({
		onClick: noop,
	}),
	withHandlers({
		handleClick:
			({ onClick, href, target }) =>
			(evt) => {
				if (href && target !== '_blank') {
					evt.preventDefault(evt);
					setLocation(href);

					const isTelTag = href.includes('tel:');
					const isMailTag = href.includes('mailto:');

					if (isTelTag || isMailTag) {
						const { target } = evt;
						const { id, className, innerText } = target;

						let tagType = isTelTag ? 'tel' : 'mailto';

						trackContactLinkClick(
							id || className,
							innerText,
							innerText,
							tagType,
						);
					}
				} else if (href && target.includes('blank')) {
					const { target } = evt;
					const { id, innerText } = target;

					trackOutboundLinkClick(
						id || 'outbound-link',
						innerText,
						innerText,
						href,
					);
				}

				Promise.resolve(onClick(evt));
			},
	}),
	setWrappedDisplayName('SegmentClickTracking'),
);

export default enhance;
